// src/features/orders/OrdersPage.jsx

import React, { useEffect, useState } from "react";
import { ordersService } from "./ordersService";
import { formatCurrency } from "../../utils/formatCurrency";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await ordersService.getOrders();
        setOrders(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load orders.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) return <p className="text-center mt-10">Loading orders...</p>;
  if (error) return <p className="text-center mt-10 text-red-500">{error}</p>;
  if (!orders.length)
    return <p className="text-center mt-10">You have no orders yet.</p>;

  return (
    <div className="max-w-4xl mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6 text-center">My Orders</h1>
      {orders.map((order, index) => (
        <div
          key={index}
          className="mb-6 p-4 border rounded shadow-sm hover:shadow-md transition"
        >
          <div className="flex justify-between mb-2">
            <span className="font-semibold">Order Date:</span>
            <span>{new Date(order.date).toLocaleString()}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="font-semibold">Payment ID:</span>
            <span>{order.paymentId || "-"}</span>
          </div>
          <div className="mb-2">
            <span className="font-semibold">Items:</span>
            <ul className="ml-4 list-disc">
              {order.items.map((item) => (
                <li key={item.id}>
                  {item.name} x {item.quantity} ={" "}
                  {formatCurrency(item.price * item.quantity)}
                </li>
              ))}
            </ul>
          </div>
          <div className="flex justify-between mt-2 font-bold text-lg">
            <span>Total:</span>
            <span>{formatCurrency(order.total)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersPage;